import { Action } from '@ngrx/store';
import { RibInterface } from '../../models/rib.interface';

export enum EPaymentMethodActions {
  UpdatePaymentMethod= '[PaymentMethod] Update payment method',
  UpdatePaymentMethodSuccess = '[PaymentMethod] Update payment method success',
  UpdatePaymentMethodFailure = '[PaymentMethod] Update payment method failure',
}

/**
 * Set update payment method success action and state to save in store
 */
export class UpdatePaymentMethod implements Action {
  public readonly type = EPaymentMethodActions.UpdatePaymentMethod;
  // payload passed as param and will be used by the effect
  constructor(public payload: RibInterface) {}
}

/**
 * Set update payment method success action and state to save in store
 */
export class UpdatePaymentMethodSuccess implements Action {
  public readonly type = EPaymentMethodActions.UpdatePaymentMethodSuccess;
}

/**
 * Set update payment method success action and state to save in store
 */
export class UpdatePaymentMethodFailure implements Action {
  public readonly type = EPaymentMethodActions.UpdatePaymentMethodFailure;
}

/**
 * Export actions : will be used in reducers
 */
export type PaymentMethodActions = UpdatePaymentMethod | UpdatePaymentMethodSuccess | UpdatePaymentMethodFailure;
